export function s_conditional(text) {
    return `

    <div class=WordSection1>

    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt'><b><span
    style='font-size:24.0pt;font-family:"Zilla Slab",serif;color:black;letter-spacing:
    .75pt'>The conditional </span></b></p>
    
    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    normal'><i><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>?</span></i></p>
    
    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    24.0pt;background:white'><b><u><span style='font-size:16.0pt;font-family:"inherit",serif;
    color:black'>1&nbsp;&nbsp;&nbsp;Using the conditional</span></u></b></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
    background:white'><span style='font-size:10.0pt;font-family:Symbol;color:black'>·<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>You can often recognize a conditional in English by the word&nbsp;<i>would</i>&nbsp;or
    its shortened form&nbsp;<i>’d</i>.</span></p>
    
    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    normal;background:white'><span style='font-size:13.5pt;font-family:"inherit",serif;
    color:black'>I&nbsp;would&nbsp;be sad if you left.If you asked him,
    he’d&nbsp;help you.</span></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
    background:white'><span style='font-size:10.0pt;font-family:Symbol;color:black'>·<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>You use the conditional for:</span></p>
    
    <p class=MsoNormal style='margin-left:9.6pt;text-indent:-3.75pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>saying what you would like to do</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>Me</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>gustaría</b>&nbsp;<b>conocerlo.</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>I’d like
      to meet him.</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='margin-left:9.6pt;text-indent:-3.75pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>making suggestions</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>Podrías</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>alquilar una
      bici.</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>You could
      hire a bike.</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='margin-left:9.6pt;text-indent:-3.75pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>giving advice</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>Deberías</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>hacer más
      ejercicio.</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>You should
      take more exercise.</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='margin-left:9.6pt;text-indent:-3.75pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>saying what you would do</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>Le
      dije que le</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:
      "inherit",serif'>&nbsp;<b>ayudaría.</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>I said I
      would help him.</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='line-height:normal;background:white'><span
    style='font-size:13.5pt;font-family:"inherit",serif;color:black'>TipThere is no
    direct Spanish translation of&nbsp;<i>would</i>&nbsp;in verb forms like&nbsp;<i>would
    be</i>,&nbsp;<i>would like</i>,&nbsp;<i>would help</i>&nbsp;and so on. You
    change the Spanish verb ending instead.</span></p>
    
    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    24.0pt;background:white'><b><u><span style='font-size:16.0pt;font-family:"inherit",serif;
    color:black'>2&nbsp;&nbsp;&nbsp;Forming the conditional</span></u></b></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
    background:white'><span style='font-size:10.0pt;font-family:Symbol;color:black'>·<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>To form the conditional of regular&nbsp;<b>-ar</b>,&nbsp;<b>-er</b>,
    and&nbsp;<b>-ir</b>&nbsp;verbs, add the following endings to the&nbsp;infinitive&nbsp;of
    the verb:&nbsp;<b>-ía</b>,&nbsp;<b>-ías</b>,&nbsp;<b>-ía</b>,&nbsp;<b>-íamos</b>,&nbsp;<b>-íais</b>,&nbsp;<b>-ían</b>.</span></p>
    
    <p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>The following table shows the conditional tense of three regular
    verbs:&nbsp;<b>hablar</b>&nbsp;(meaning&nbsp;<i>to speak</i>),&nbsp;<b>comer</b>&nbsp;(meaning&nbsp;<i>to
    eat</i>) and&nbsp;<b>vivir</b>&nbsp;(meaning&nbsp;<i>to live</i>).</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>(yo)</span></b></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>hablaría</span></b></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>comería</span></b></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>viviría</span></b></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>I would
      speak/eat/live</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>(tú)</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>hablarías</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>comerías</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>vivirías</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>you would
      speak/eat/live</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>(él)</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'><br>
      <br>
      <b>(ella)</b><br>
      <br>
      <br>
      <br>
      <b>(usted)</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>hablaría</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>comería</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>viviría</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>he would<br>
      speak/eat/live<br>
      she would<br>
      speak/eat/live<br>
      it would<br>
      speak/eat/live<br>
      you would<br>
      speak/eat/live</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>(nosotros/nosotras)</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>hablaríamos</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>comeríamos</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>viviríamos</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>we would<br>
      speak/eat/live</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>(vosotros/vosotras)</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>hablaríais</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>comeríais</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>viviríais</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>you would<br>
      speak/eat/live</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>(ellos/ellas)</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'><br>
      <br>
      <b>(ustedes)</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>hablarían</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>comerían</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>vivirían</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>they would<br>
      speak/eat/live<br>
      you would<br>
      speak/eat/live</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='line-height:normal;background:white'><span
    style='font-size:12.0pt;font-family:"Open Sans",sans-serif;color:black;
    display:none'>&nbsp;</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>Dije
      que</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>hablaría</b>&nbsp;<b>con
      ella.</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>I said
      that I would speak to her.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>Si
      tuvieras tiempo,</span></b><span lang=ES-MX style='font-size:12.0pt;
      font-family:"inherit",serif'>&nbsp;<b>comería</b>&nbsp;<b>contigo.</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>I’d have
      lunch with you if you had time.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>Aquí</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>viviríais</b>&nbsp;<b>más
      tranquilos.</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>You’d have
      a quieter life here.</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    normal;background:white'><span style='font-size:13.5pt;font-family:"inherit",serif;
    color:black'>TipDon’t forget to put an accent on the&nbsp;<b>í</b>&nbsp;in the
    conditional.</span></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
    background:white'><span style='font-size:10.0pt;font-family:Symbol;color:black'>·<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>Note that the endings in the conditional tense are identical to
    those of the&nbsp;imperfect tense&nbsp;for&nbsp;<b>-er</b>&nbsp;and&nbsp;<b>-ir</b>&nbsp;verbs.
    The only difference is that they are added to a different stem.</span></p>
    
    <p class=MsoNormal style='margin-left:9.6pt;text-indent:-3.75pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><i><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>For more information on the</span></i><span style='font-size:12.0pt;
    font-family:"inherit",serif;color:black'>&nbsp;<b><i>Imperfect tense</i></b>,&nbsp;<i>see&nbsp;<a
    href="https://grammar.collinsdictionary.com/spanish-easy-learning/the-imperfect-tense"
    title="Explanation of The imperfect tense"><span style='color:blue'>The
    imperfect tense</span></a></i>.</span></p>
    
    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    24.0pt;background:white'><b><u><span style='font-size:16.0pt;font-family:"inherit",serif;
    color:black'>3&nbsp;&nbsp;&nbsp;Verbs with irregular stems in the conditional</span></u></b></p>
    
    <p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>To form the conditional of irregular verbs, use the same stem as
    for the&nbsp;future tense, then add the usual endings for the conditional. The
    same verbs that are irregular in the future tense are irregular in the
    conditional.</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>Verb</span></b></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>Stem</span></b></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>(yo)</span></b></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>(tú)</span></b></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>(él)</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'><br>
      <b>(ella)</b><br>
      <b>(usted)</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>(nosotros)</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'><br>
      <b>(nosotras)</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>(vosotros)</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'><br>
      <b>(vosotras)</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>(ellos)</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'><br>
      <b>(ellas)</b><br>
      <b>(ustedes)</b></span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>decir</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'><br>
      to say</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>dir-</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>diría</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>dirías</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>diría</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>diríamos</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>diríais</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>dirían</span></b></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>haber</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'><br>
      to have</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>habr-</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>habría</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>habrías</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>habría</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>habríamos</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>habríais</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>habrían</span></b></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>hacer</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'><br>
      to do/<br>
      make</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>har-</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>haría</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>harías</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>haría</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>haríamos</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>haríais</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>harían</span></b></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>poder</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'><br>
      to be<br>
      able to</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>podr-</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>podría</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>podrías</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>podría</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>podríamos</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>podríais</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>podrían</span></b></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>poner</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'><br>
      to put</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>pondr-</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>pondría</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>pondrías</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>pondría</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>pondríamos</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>pondríais</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>pondrían</span></b></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>querer</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'><br>
      to want</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>querr-</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>querría</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>querrías</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>querría</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>querríamos</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>querríais</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>querrían</span></b></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>saber</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'><br>
      to know</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>sabr-</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>sabría</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>sabrías</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>sabría</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>sabríamos</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>sabríais</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>sabrían</span></b></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>salir</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'><br>
      to leave</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>saldr-</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>saldría</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>saldrías</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>saldría</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>saldríamos</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>saldríais</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>saldrían</span></b></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>tener</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'><br>
      to have</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>tendr-</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>tendría</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>tendrías</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>tendría</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>tendríamos</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>tendríais</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>tendrían</span></b></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>venir</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'><br>
      to come</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>vendr-</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>vendría</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>vendrías</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>vendría</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>vendríamos</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>vendríais</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>vendrían</span></b></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='margin-left:9.6pt;text-indent:-3.75pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><i><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>For more information on the</span></i><span style='font-size:12.0pt;
    font-family:"inherit",serif;color:black'>&nbsp;<b><i>Future tense</i></b><i>,
    see&nbsp;<a
    href="https://grammar.collinsdictionary.com/spanish-easy-learning/the-future-tense"
    title="Explanation of The future tense"><span style='color:blue'>The future
    tense</span></a>.</i></span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&iquest;Qué</span></b><span
      lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>harías</b>&nbsp;<b>tú
      en mi lugar?</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>What would
      you do if you were me?</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>&iquest;Podrías</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>ayudarme?</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>Could you
      help me?</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>Yo lo</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>pondría</b>&nbsp;<b>aquí.</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>I would
      put it here.</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
    background:white'><span style='font-size:10.0pt;font-family:Symbol;color:black'>·<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>Note that the verb&nbsp;<b>haber</b>&nbsp;is only used when
    forming other tenses, such as the perfect tense, and in the expression&nbsp;<b>hay</b>&nbsp;(meaning&nbsp;<i>there
    is/there are</i>).</span></p>
    
    <p class=MsoNormal style='margin-left:9.6pt;text-indent:-3.75pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><i><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>For more information on the</span></i><span style='font-size:12.0pt;
    font-family:"inherit",serif;color:black'>&nbsp;<b><i>Perfect tense</i></b><i>&nbsp;and
    on</i>&nbsp;<b><i>hay</i></b><i>, see&nbsp;<a
    href="https://grammar.collinsdictionary.com/spanish-easy-learning/the-perfect-tense"
    title="Explanation of The perfect tense"><span style='color:blue'>The perfect
    tense</span></a>.</i></span></p>
    
    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    24.0pt;background:white'><b><u><span style='font-size:16.0pt;font-family:"inherit",serif;
    color:black'>4&nbsp;&nbsp;&nbsp;Reflexive verbs in the conditional</span></u></b></p>
    
    <p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>The conditional of reflexive verbs is formed in just the same way
    as for ordinary verbs, except that you have to remember to give the reflexive
    pronoun (<b>me</b>,&nbsp;<b>te</b>,&nbsp;<b>se</b>,&nbsp;<b>nos</b>,&nbsp;<b>os</b>,&nbsp;<b>se</b>).</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>Le
      dije que</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>me
      levantaría</b>&nbsp;<b>temprano.</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>I told him
      I would get up early.</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    normal;background:#E1E4EE'><span style='font-size:13.5pt;font-family:"inherit",serif;
    color:black'>Key points</span></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
    background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
    color:#B71533'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>In Spanish, there is no direct equivalent of the word&nbsp;</span><i><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:black'>would</span></i><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>&nbsp;in
    verb forms like&nbsp;</span><i><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>would go</span></i><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>&nbsp;and&nbsp;</span><i><span style='font-size:12.0pt;
    font-family:"inherit",serif;color:black'>would look</span></i><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>&nbsp;and so
    on. You change the verb ending instead.</span></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
    background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
    color:#B71533'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>To form the conditional tense, add the endings&nbsp;</span><b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:black'>-ía,</span></b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>&nbsp;ías,&nbsp;</span><b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:black'>-ía</span></b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>,</span><b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:black'>-íamos</span></b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>,&nbsp;</span><b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:black'>-íais</span></b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>,&nbsp;</span><b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:black'>-ían</span></b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>&nbsp;to the
    infinitive. The conditional uses the same stem as for the future.</span></p>
    
    <p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
    normal;background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
    color:#B71533'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>Some verbs have irregular stems which are used for both the
    conditional and the future. It is worth learning these.</span></p>
    
    <p class=MsoNormal>&nbsp;</p>
    
    </div>


    `;
}
